import { shipmentTypes } from "../actions/shipment";

const initialState = {
  shipmentTitlesForFilter: [],
  shipmentTitlesForHighlight: [],
  trackDataLoaded: false,
  isLoading: {
    shipments: false,
    map: false,
    shipProfile: false,
    alertGroup: false,
    updateState: false,
    deviceName: false,
    bulkUpdateState: false,
  },
  isDownloaded: "",
  msg: "",
  shouldUpdate: false,
  ui: {
    notification: {
      isActive: false,
      type: "success",
      message: "",
      description: "",
      style: { backgroundColor: "#d4edda", color: "#155724" },
    },
    shipBleDeviceId: "",
    shipNewBleDeviceId: "",
    selectedFields: [],
    selectedDeviceDetails: [],
    delete: {
      deletedField: {},
      singleDelete: false,
      bulkDelete: false,
    },
    location: {
      coordinates: "",
      locationdetails: "",
      datatimestamp: "",
      battery: "",
      temperature: "",
    },
    create: {
      isOpen: false,
      selectedProfileId: null,
      isCheckboxChecked: false,
      bleProfile: "",
    },
    edit: {
      bulkEdit: false,
      bulkEditFormData: {
        state: "",
        startDate: new Date(),
        profile: undefined,
        onShipmentCompletion: undefined,
      },
      singleEdit: false,
      updateState: false,
      bulkUpdateState: false,
      currentUpdateState: {
        selected: {},
        formData: {
          state: "",
        },
      },
    },
    cancel: {
      cancelField: {},
      singleCancel: false,
      bulkCancel: false,
    },
    clone: {
      isClone: false,
      step: 1,
      isSaved: false,
      editRecord: {},
      selectedProfileId: null,
      isCheckboxChecked: false,
      bleProfile: "",
      ble: [],
      editorClone: "",
      editField: {
        shipmentName: {
          isValid: true,
          class: "",
          value: "",
          error: "",
        },
        shipmentid: {
          value: "",
        },
        devicename: {
          value: "",
        },
        selectProfile: {
          isValid: true,
          class: "",
          value: {},
          error: "",
        },
        state: {
          isValid: true,
          class: "",
          value: "",
          error: "",
        },
        startDate: {
          isValid: true,
          class: "",
          value: new Date(),
          error: "",
        },
        devicetype: {
          isValid: true,
          class: "",
          value: "",
          error: "",
        },
        deviceId: {
          isValid: true,
          class: "",
          value: "",
          error: "",
        },
        profile: {
          isValid: true,
          class: "",
          value: {},
          error: "",
        },
        isBLEEnabled: {
          isValid: true,
          class: "",
          value: "no",
          error: "",
        },
        onShipmentCompletion: {
          isValid: true,
          class: "",
          value: "Keep this device profile",
          error: "",
        },
        bleDetails: [],
        productSerialNumber: {
          isValid: true,
          class: "",
          value: "",
          error: "",
        },
        trackingNumber: {
          isValid: true,
          class: "",
          value: "",
          error: "",
        },
        orderNumber: {
          isValid: true,
          class: "",
          value: "",
          error: "",
        },
        customerName: {
          isValid: true,
          class: "",
          value: "",
          error: "",
        },
        poNumber: {
          isValid: true,
          class: "",
          value: "",
          error: "",
        },
      },
    },
    editShipment: {
      isEditShipment: false,
      step: 1,
      isSaved: false,
      editRecord: {},
      selectedProfileId: null,
      isCheckboxChecked: false,
      bleProfile: "",
      ble: [],
      editorClone: "",
      editField: {
        shipmentName: {
          isValid: true,
          class: "",
          value: "",
          error: "",
        },
        shipmentid: {
          value: "",
        },
        devicename: {
          value: "",
        },
        selectProfile: {
          isValid: true,
          class: "",
          value: {},
          error: "",
        },
        state: {
          isValid: true,
          class: "",
          value: "",
          error: "",
        },
        startDate: {
          isValid: true,
          class: "",
          value: new Date(),
          error: "",
        },
        devicetype: {
          isValid: true,
          class: "",
          value: "",
          error: "",
        },
        deviceId: {
          isValid: true,
          class: "",
          value: "",
          error: "",
        },
        profile: {
          isValid: true,
          class: "",
          value: {},
          error: "",
        },
        isBLEEnabled: {
          isValid: true,
          class: "",
          value: "no",
          error: "",
        },
        onShipmentCompletion: {
          isValid: true,
          class: "",
          value: "Keep this device profile",
          error: "",
        },
        bleDetails: [],
        productSerialNumber: {
          isValid: true,
          class: "",
          value: "",
          error: "",
        },
        trackingNumber: {
          isValid: true,
          class: "",
          value: "",
          error: "",
        },
        orderNumber: {
          isValid: true,
          class: "",
          value: "",
          error: "",
        },
        customerName: {
          isValid: true,
          class: "",
          value: "",
          error: "",
        },
        poNumber: {
          isValid: true,
          class: "",
          value: "",
          error: "",
        },
      },
    },
  },
  filters: {
    currentChangedFilterField: "",
    status: {
      sort: "",
      option: [
        {
          text: "Active",
          value: "header",
        },
        {
          text: "No Alert",
          value: false,
        },
        {
          text: "Warning",
          value: false,
        },
        {
          text: "Critical",
          value: false,
        },
        {
          text: "Notification",
          value: false,
        },
        {
          text: "Inactive",
          value: "header",
        },
        {
          text: "Completed",
          value: false,
        },
      ],
    },
    shipmentName: {
      sort: "asc",
      option: "",
    },
    state: {
      sort: "",
      option: [
        {
          text: "In Progress",
          value: true,
        },
        {
          text: "Scheduled",
          value: true,
        },
        {
          text: "Completed",
          value: false,
        },
        {
          text: "Cancelled",
          value: false,
        },
      ],
    },
    startDate: {
      sort: "asc",
      option: {
        startdatefrom: "",
        startdateto: "",
      },
    },
    lastUpdated: {
      sort: "asc",
      option: {
        lastupdatedfrom: "",
        lastupdatedto: "",
      },
    },
  },
  data: {
    pageSize: 10,
    currentPage: 1,
    count: 0,
    allShipments: [],
    shipments: [],
    deviceType: [],
    shipProfile: [],
    alertGroup: [],
    deviceName: [],
    alertsContent: {
      shipmentData: null,
      isLoading: false,
      error: null,
    },
    map: {
      isFullScreen: false,
      originCoordinates: [-100.0, 31.0],
      destinationCoordinates: [-75.0, 43.0],
      currentCoordinates: [-100.0, 31.0],
    },
    query: {
      shipmentstate: ["In Progress", "Scheduled"],
      $sort: [{ field: "updatedat", order: "desc" }],
    },
  },
  shipmentTrackData: [],
  activeTabGlobal: null,
  shipmentData: null,
  shipmentStatus: null,
  error: null,
};

const shipmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case shipmentTypes.FETCH_REQUEST:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          shipments: true,
        },
        data: {
          ...state.data,
          currentPage: action.payload ? action.payload : state.data.currentPage,
        },
      };
    case shipmentTypes.FETCH_SUCCESS:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          shipments: false,
        },
        data: {
          ...state.data,
          ...action.payload,
        },
        error: null,
      };
    case shipmentTypes.FETCH_FAILURE:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          shipments: false,
        },
        error: action.payload,
      };
    case shipmentTypes.UPDATE_REQUEST:
      return {
        ...state,
        ...action.payload,
      };
    case shipmentTypes.UPDATE_UI:
      return {
        ...state,
        ui: {
          ...state.ui,
          [action.payload.key]: {
            ...state.ui[action.payload.key],
            ...action.payload.value,
          },
        },
      };
    case shipmentTypes.FETCH_LOCATION_ALERTS_SUCCESS:
      return {
        ...state,
        shipmentTrackData: action.payload,
        trackDataLoaded: true,
      };
    case shipmentTypes.FETCH_LOCATION_ALERTS:
      return {
        ...state,
        trackDataLoaded: false,
      };
    case shipmentTypes.SET_TRACK_DATA_LOADED:
      return {
        ...state,
        trackDataLoaded: false,
      };
    case shipmentTypes.UPDATE_FILTER:{
      return {
        ...state,
        shouldUpdate: !state.shouldUpdate,
        filters: {
          ...state.filters,
          currentChangedFilterField: action.payload.key,
          shipmentid: { sort: "asc", option: [] },
          [action.payload.key]: action.payload.value,
        },
        data: {
          ...state.data,
          currentPage: 1,
        },
      };
    }
    case shipmentTypes.CLEAR_FILTER:
      return {
        ...state,
        shouldUpdate: !state.shouldUpdate,
        ui: {
          ...state.ui,
          notification: {
            isActive: false,
            type: "success",
            message: "",
            description: "",
            style: { backgroundColor: "#d4edda", color: "#155724" },
          },
          selectedFields: [],
        },
        filters: {
          ...state.filters,
          currentChangedFilterField: "",
          status: {
            sort: "",
            option: [
              {
                text: "Active",
                value: "header",
              },
              {
                text: "No Alert",
                value: false,
              },
              {
                text: "Warning",
                value: false,
              },
              {
                text: "Critical",
                value: false,
              },
              {
                text: "Notification",
                value: false,
              },
              {
                text: "Inactive",
                value: "header",
              },
              {
                text: "Completed",
                value: false,
              },
            ],
          },
          shipmentName: {
            sort: "asc",
            option: "",
          },
          state: {
            sort: "",
            option: [
              {
                text: "In Progress",
                value: true,
              },
              {
                text: "Scheduled",
                value: true,
              },
              {
                text: "Completed",
                value: false,
              },
              {
                text: "Cancelled",
                value: false,
              },
            ],
          },
          startDate: {
            sort: "asc",
            option: {
              startdatefrom: "",
              startdateto: "",
            },
          },
          lastUpdated: {
            sort: "asc",
            option: {
              lastupdatedfrom: "",
              lastupdatedto: "",
            },
          },
        },
        data: {
          ...state.data,
          currentPage: 1,
          query: {
            shipmentstate: ["In Progress", "Scheduled"],
            $sort: [{ field: "updatedat", order: "desc" }],
          },
        },
      };
    case shipmentTypes.UPDATE_BULK_SELECT:
      return {
        ...state,
        ui: {
          ...state.ui,
          selectedFields: action.payload,
        },
      };
    case shipmentTypes.FETCH_DEVICE_DETAILS:
      return {
        ...state,
        ui: {
          ...state.ui,
          ...action.payload,
        },
      };
    case shipmentTypes.UPDATE_PAGINATION_REQUEST:
      return {
        ...state,
        shouldUpdate: action.payload.shouldUpdate,
        data: {
          ...state.data,
          ...action.payload.data,
        },
      };
    case shipmentTypes.FETCH_DEVICE_REQUEST:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          shipProfile: true,
        },
      };
    case shipmentTypes.FETCH_DEVICE_SUCCESS:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          shipProfile: false,
        },
        data: {
          ...state.data,
          ...action.payload,
        },
        error: null,
      };
    case shipmentTypes.FETCH_DEVICE_FAILURE:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          shipProfile: false,
        },
        error: action.payload,
      };
    case shipmentTypes.FETCH_PROFILE_REQUEST:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          shipProfile: true,
        },
      };
    case shipmentTypes.FETCH_PROFILE_SUCCESS:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          shipProfile: false,
        },
        data: {
          ...state.data,
          ...action.payload,
        },
        error: null,
      };
    case shipmentTypes.FETCH_PROFILE_FAILURE:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          shipProfile: false,
        },
        error: action.payload,
      };
    case shipmentTypes.FETCH_ALERT_REQUEST:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          alertGroup: true,
        },
        data: {
          ...state.data,
          currentPage: action.payload ? action.payload : state.data.currentPage,
        },
      };
    case shipmentTypes.FETCH_ALERT_SUCCESS:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          alertGroup: false,
        },
        data: {
          ...state.data,
          ...action.payload,
        },
        error: null,
      };
    case shipmentTypes.FETCH_ALERT_FAILURE:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          alertGroup: false,
        },
        error: action.payload,
      };
    case shipmentTypes.DOWNLOAD_REQUEST:
      return {
        ...state,
        isDownloaded: "Downloading....",
      };
    case shipmentTypes.DOWNLOAD_SUCCESS:
      return {
        ...state,
        isDownloaded: "Downloaded",
      };
    case shipmentTypes.DOWNLOAD_FAILURE:
      return {
        ...state,
        isDownloaded: "Something Went Wrong",
        error: action.payload,
      };
    case shipmentTypes.CREATE_REQUEST:
      return {
        ...state,
        msg: "Creating....",
      };
    case shipmentTypes.CREATE_SUCCESS:
      return {
        ...state,
        msg: "Created",
        shouldUpdate: !state.shouldUpdate,
        ui: {
          ...state.ui,
          notification: {
            ...state.ui.notification,
            type: "success",
            isActive: true,
            message: "Create Shipment",
            description: action.payload,
            style: { backgroundColor: "#FFECE0", color: "#000" },
          },
        },
      };
    case shipmentTypes.CREATE_FAILURE:
      return {
        ...state,
        msg: "Something Went Wrong",
        error: action.payload,
        ui: {
          ...state.ui,
          notification: {
            ...state.ui.notification,
            type: "error",
            isActive: true,
            message: "Create Shipment",
            description: action.payload,
            style: { backgroundColor: "#FFECE0", color: "#000" },
          },
        },
      };
    case shipmentTypes.UPDATE_SHIP_REQUEST:
      return {
        ...state,
        msg: "Updating....",
      };
    case shipmentTypes.UPDATE_SHIP_SUCCESS:
      return {
        ...state,
        msg: "Updated",
        shouldUpdate: !state.shouldUpdate,
        ui: {
          ...state.ui,
          notification: {
            ...state.ui.notification,
            type: "success",
            isActive: true,
            message: "Update Shipment",
            description: action.payload,
            style: { backgroundColor: "#FFECE0", color: "#000" },
          },
        },
      };
    case shipmentTypes.UPDATE_SHIP_FAILURE:
      return {
        ...state,
        msg: "Something Went Wrong",
        ui: {
          ...state.ui,
          notification: {
            ...state.ui.notification,
            type: "error",
            isActive: true,
            message: "Update Shipment",
            description: action.payload,
            style: { backgroundColor: "#FFECE0", color: "#000" },
          },
        },
        error: action.payload,
      };
    case shipmentTypes.SINGLE_DELETE_REQUEST:
      return {
        ...state,
        shouldUpdate: false,
        ui: {
          ...state.ui,
          delete: {
            ...state.ui.delete,
            ...action.payload,
          },
        },
      };
    case shipmentTypes.SINGLE_DELETE_SUCCESS:
      return {
        ...state,
        shouldUpdate: true,
        ui: {
          ...state.ui,
          delete: {
            ...state.ui.delete,
            deletedField: {},
            singleDelete: false,
          },
          notification: {
            ...state.ui.notification,
            isActive: true,
            message: "Delete",
            description: action.payload,
          },
        },
        msg: action.payload,
        error: null,
      };
    case shipmentTypes.SINGLE_DELETE_FAILURE:
      return {
        ...state,
        shouldUpdate: false,
        ui: {
          ...state.ui,
          delete: {
            ...state.ui.delete,
            deletedField: {},
            singleDelete: false,
          },
          notification: {
            ...state.ui.notification,
            type: "error",
            isActive: true,
            message: "Delete Error",
            description: action.payload,
            style: { backgroundColor: "#FFECE0", color: "#000" },
          },
        },
        msg: "Something Went Wrong",
        error: action.payload,
      };
    case shipmentTypes.BULK_DELETE_REQUEST:
      return {
        ...state,
        shouldUpdate: false,
      };
    case shipmentTypes.BULK_DELETE_SUCCESS:
      return {
        ...state,
        shouldUpdate: true,
        ui: {
          ...state.ui,
          selectedFields: [],
          delete: {
            ...state.ui.delete,
            bulkDelete: false,
          },
          notification: {
            ...state.ui.notification,
            isActive: true,
            message: "Bulk Delete",
            description: action.payload,
          },
        },
        msg: action.payload,
        error: null,
      };
    case shipmentTypes.BULK_DELETE_FAILURE:
      return {
        ...state,
        shouldUpdate: false,
        ui: {
          ...state.ui,
          selectedFields: [],
          delete: {
            ...state.ui.delete,
            bulkDelete: false,
          },
          notification: {
            ...state.ui.notification,
            type: "error",
            isActive: true,
            message: "Bulk Delete Error",
            description: action.payload,
            style: { backgroundColor: "#FFECE0", color: "#000" },
          },
        },
        msg: "Something Went Wrong",
        error: action.payload,
      };
    case shipmentTypes.SINGLE_CANCEL_REQUEST:
      return {
        ...state,
        shouldUpdate: false,
        ui: {
          ...state.ui,
          cancel: {
            ...state.ui.cancel,
            ...action.payload,
          },
        },
      };
    case shipmentTypes.SINGLE_CANCEL_SUCCESS:
      return {
        ...state,
        shouldUpdate: true,
        ui: {
          ...state.ui,
          cancel: {
            ...state.ui.cancel,
            cancelField: {},
            singleCancel: false,
          },
          notification: {
            ...state.ui.notification,
            isActive: true,
            message: "Cancel",
            description: action.payload,
          },
        },
        msg: action.payload,
        error: null,
      };
    case shipmentTypes.SINGLE_CANCEL_FAILURE:
      return {
        ...state,
        shouldUpdate: false,
        ui: {
          ...state.ui,
          cancel: {
            ...state.ui.cancel,
            cancelField: {},
            singleCancel: false,
          },
          notification: {
            ...state.ui.notification,
            type: "error",
            isActive: true,
            message: "Cancel Error",
            description: action.payload,
            style: { backgroundColor: "#FFECE0", color: "#000" },
          },
        },
        msg: "Something Went Wrong",
        error: action.payload,
      };
    case shipmentTypes.BULK_CANCEL_REQUEST:
      return {
        ...state,
        shouldUpdate: false,
      };
    case shipmentTypes.BULK_CANCEL_SUCCESS:
      return {
        ...state,
        shouldUpdate: true,
        ui: {
          ...state.ui,
          selectedFields: [],
          cancel: {
            ...state.ui.cancel,
            bulkCancel: false,
          },
          notification: {
            ...state.ui.notification,
            isActive: true,
            message: "Bulk Cancelled",
            description: action.payload,
          },
        },
        msg: action.payload,
        error: null,
      };
    case shipmentTypes.BULK_CANCEL_FAILURE:
      return {
        ...state,
        shouldUpdate: false,
        ui: {
          ...state.ui,
          selectedFields: [],
          cancel: {
            ...state.ui.cancel,
            bulkCancel: false,
          },
          notification: {
            ...state.ui.notification,
            type: "error",
            isActive: true,
            message: "Bulk Cancel Error",
            description: action.payload,
            style: { backgroundColor: "#FFECE0", color: "#000" },
          },
        },
        msg: "Something Went Wrong",
        error: action.payload,
      };
    case shipmentTypes.SINGLE_UPDATE_STATE_REQUEST:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          updateState: true,
        },
      };
    case shipmentTypes.SINGLE_UPDATE_STATE_SUCCESS:
      return {
        ...state,
        shouldUpdate: !state.shouldUpdate,
        isLoading: {
          ...state.isLoading,
          updateState: false,
        },
        ui: {
          ...state.ui,
          edit: {
            ...state.ui.edit,
            updateState: false,
            currentUpdateState: {
              selected: {},
              formData: {
                state: "",
              },
            },
          },
          notification: {
            ...state.ui.notification,
            isActive: true,
            message: "Update State",
            description: action.payload,
          },
        },
        msg: action.payload,
        error: null,
      };
    case shipmentTypes.SINGLE_UPDATE_STATE_FAILURE:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          updateState: false,
        },
        ui: {
          ...state.ui,
          edit: {
            ...state.ui.edit,
            updateState: false,
            currentUpdateState: {
              selected: {},
              formData: {
                state: "",
              },
            },
          },
          notification: {
            ...state.ui.notification,
            type: "error",
            isActive: true,
            message: "Update State Error",
            description: action.payload,
            style: { backgroundColor: "#FFECE0", color: "#000" },
          },
        },
        msg: "Something Went Wrong",
        error: action.payload,
      };
    case shipmentTypes.BULK_EDIT_REQUEST:
      return {
        ...state,
      };
    case shipmentTypes.BULK_EDIT_SUCCESS:
      return {
        ...state,
        shouldUpdate: !state.shouldUpdate,
        ui: {
          ...state.ui,
          selectedFields: [],
          edit: {
            ...state.ui.edit,
            bulkEdit: false,
            bulkEditFormData: {
              state: "",
              startDate: new Date(),
              profile: undefined,
              onShipmentCompletion: undefined,
            },
          },
          notification: {
            ...state.ui.notification,
            isActive: true,
            message: "Bulk Edit",
            description: action.payload,
          },
        },
        msg: action.payload,
        error: null,
      };
    case shipmentTypes.BULK_EDIT_FAILURE:
      return {
        ...state,
        shouldUpdate: false,
        ui: {
          ...state.ui,
          selectedFields: [],
          edit: {
            ...state.ui.edit,
            bulkEdit: false,
            bulkEditFormData: {
              state: "",
              startDate: new Date(),
              profile: undefined,
              onShipmentCompletion: undefined,
            },
          },
          notification: {
            ...state.ui.notification,
            type: "error",
            isActive: true,
            message: "Bulk Edit Error",
            description: action.payload,
            style: { backgroundColor: "#FFECE0", color: "#000" },
          },
        },
        msg: "Something Went Wrong",
        error: action.payload,
      };
    case shipmentTypes.FETCH_DEVICE_NAME_REQUEST:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          deviceName: true,
        },
        data: {
          ...state.data,
        },
      };
    case shipmentTypes.FETCH_DEVICE_NAME_SUCCESS:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          deviceName: false,
        },
        data: {
          ...state.data,
          ...action.payload,
        },
        error: null,
      };
    case shipmentTypes.FETCH_DEVICE_NAME_FAILURE:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          deviceName: false,
        },
        error: action.payload,
      };
    case shipmentTypes.FETCH_ALERTS_CONTENT_REQUEST:
      return {
        ...state,
        data: {
          ...state.data,
          alertsContent: {
            ...state.data.alertsContent,
            isLoading: true,
            error: null,
          },
        },
      };
    case shipmentTypes.FETCH_ALERTS_CONTENT_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          alertsContent: {
            ...state.data.alertsContent,
            shipmentData: action.payload.shipmentData,
            isLoading: false,
            error: null,
          },
        },
      };
    case shipmentTypes.FETCH_ALERTS_CONTENT_FAILURE:
      return {
        ...state,
        data: {
          ...state.data,
          alertsContent: {
            ...state.data.alertsContent,
            isLoading: false,
            error: action.payload,
          },
        },
      };
    case shipmentTypes.SET_ACTIVE_TAB_GLOBAL:
      return {
        ...state,
        ...action.payload,
      };
    case shipmentTypes.SET_SHIPMENT_DATA:
      return {
        ...state,
        shipmentData: action.payload,
      };
    case shipmentTypes.SET_SHIPMENT_STATUS:
      return {
        ...state,
        shipmentStatus: action.payload,
      };
    case shipmentTypes.UPDATE_MAP:
      return {
        ...state,
        data: {
          ...state.data,
          map: {
            ...state.data.map,
            ...action.payload,
          },
        },
      };
    case shipmentTypes.UPDATE_IS_LOADING:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          map: action.payload,
        },
      };
    case shipmentTypes.BULK_UPDATE_STATE_REQUEST:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          bulkUpdateState: true,
        },
      };
    case shipmentTypes.SET_SHIPMENT_TITLES_FOR_FILTER:
      return {
        ...state,
        shipmentTitlesForFilter: action.payload,
      };
    case shipmentTypes.SET_SHIPMENT_TITLES_FOR_HIGHLIGHT:
      return {
        ...state,
        shipmentTitlesForHighlight: action.payload,
      };
    case shipmentTypes.BULK_UPDATE_STATE_SUCCESS:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          bulkUpdateState: false,
        },
        shouldUpdate: !state.shouldUpdate,
        ui: {
          ...state.ui,
          selectedFields: [],
          edit: {
            ...state.ui.edit,
            bulkUpdateState: false,
          },
          notification: {
            ...state.ui.notification,
            isActive: true,
            message: "Bulk Update State",
            description: action.payload,
          },
        },
        msg: action.payload,
        error: null,
      };
    case shipmentTypes.BULK_UPDATE_STATE_FAILURE:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          bulkUpdateState: false,
        },
        ui: {
          ...state.ui,
          edit: {
            ...state.ui.edit,
            bulkUpdateState: false,
          },
          notification: {
            ...state.ui.notification,
            type: "error",
            isActive: true,
            message: "Bulk Update State Error",
            description: action.payload,
            style: { backgroundColor: "#FFECE0", color: "#000" },
          },
        },
        msg: "Something Went Wrong",
        error: action.payload,
      };
    case shipmentTypes.LOGOUT:
      return initialState;
    case shipmentTypes.FETCH_ALL_REQUEST:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          map: true,
        },
        data: {
          ...state.data,
          currentPage: action.payload ? action.payload : state.data.currentPage,
        },
      };
    case shipmentTypes.FETCH_ALL_SUCCESS:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          map: false,
        },
        data: {
          ...state.data,
          ...action.payload,
        },
        error: null,
      };
    case shipmentTypes.FETCH_ALL_FAILURE:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          map: false,
        },
        error: action.payload,
      };

    default:
      return state;
  }
};

export default shipmentReducer;
